export default __webpack_public_path__ + "static/media/sharing.8c593f37.jpg";